export enum Region {
  INDIA = 'INDIA',
  US = 'US'
}

export enum ProjectType {
  CAPITAL = 'CAPITAL',
  SOVRN = 'SOVRN',
  SVN = 'SVN'
}

export enum LoginMode {
  Password = 'Password',
  PasswordWithOtp = 'PasswordWithOtp'
}

export enum OtpChannel {
  Mobile = 'Mobile',
  Email = 'Email'
}

export enum ResetType {
  PASSWORD = 'PASSWORD',
  MFA = 'MFA',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  DEVICE = 'DEVICE',
  SESSIONS = 'SESSIONS',
  UNLOCK = 'UNLOCK'
}

export interface AssignClientRoleRequestDTO {
  userId: string;
  clientName: string;
  roleName: string;
  region: Region;
}

export interface AssignRolesRequest {
  client?: ProjectType;
  roles: string[];
}

export interface ChangePasswordRequest {
  userId: string;
  newPassword: string;
}

export interface CompleteLoginRequest {
  mfaProof: string;
  codeChallenge?: string;
  redirectUri?: string;
}

export interface CreateRoleRequest {
  client?: ProjectType;
  roleName: string;
  description?: string;
  region: Region;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  setRandomPassword?: boolean;
  forcePasswordChange?: boolean;
  sendActivationEmail?: boolean;
  isActive?: boolean;
  region: Region;
}

export interface LoginRequest {
  username: string;
  password: string;
  loginMode?: LoginMode;
}

export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  [key: string]: any;
}

export interface RefreshRequest {
  refreshToken: string;
}

export interface ResendVerificationRequest {
  userId: string;
}

export interface ResetApplyRequest {
  newPassword?: string;
  newPhone?: string;
  newEmail?: string;
}

export interface ResetStartRequest {
  resetType?: ResetType;
  identifier?: string;
  otpChannel?: OtpChannel;
}

export interface ResetVerifyRequest {
  rtxId?: string;
  otp?: string;
}

export interface SetUserRequest {
  userId: string;
  enabled?: boolean;
}

export interface VerifyEmailRequest {
  token: string;
}

export interface VerifyOtpRequest {
  mfaTxnId: string;
  otp: string;
}
